import { type ChangeEvent, useState } from 'react'
import { toast } from 'sonner'
import {
  useOrderFormComponentStore,
  useOrderFormComponentStoreActions,
} from '../stores/order-form-component.store'
import { useOrderFormStore } from '../stores/order-form.store'
import { useModalLoadExcelComponentData } from '../components/cart/excel-upload/modal-upload-excel-component.data'

export const useModalLoadExcelComponent = () => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null)

  const {
    jsonOrderForm,
    actions: { setUpdatedProductDetails, setIsCalculationOrder },
  } = useOrderFormStore()
  const { isOpenModalLoadExcel } = useOrderFormComponentStore()
  const { setIsOpenModalLoadExcel } = useOrderFormComponentStoreActions
  const modalLoadExcelComponentData = useModalLoadExcelComponentData()

  const handleChangeFile = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setSelectedFile(event.target.files[0])
    }
  }

  const handleUpload = () => {
    if (!selectedFile) {
      toast.info('Selecione um arquivo antes de salvar.')
      return
    }

    const formData = new FormData()
    formData.append('arquivo', selectedFile)

    modalLoadExcelComponentData.action.onSubmitRequest({
      payload: {
        controlaLucratividade: jsonOrderForm?.operacao?.controlaLucratividade,
        tabelaPreco: jsonOrderForm?.fkTabelaPreco,
				fkVigencia: jsonOrderForm?.fkVigencia,
        orderId: jsonOrderForm?.idPedidoCel,
        file: selectedFile,
        jsonData: jsonOrderForm,
      },
    })

    setIsCalculationOrder(true)
    setUpdatedProductDetails(true)
  }

  const handleCloseModalLoadExcel = () => {
    setIsOpenModalLoadExcel(false)
  }

  return {
    isOpenModalLoadExcel,
    isLoading: modalLoadExcelComponentData.state.isLoadingRequest,
    handleUpload,
    handleChangeFile,
    handleCloseModalLoadExcel,
  }
}
